import { render, staticRenderFns } from "./ellipsis.vue?vue&type=template&id=57ffd7fc&scoped=true&"
import script from "./ellipsis.vue?vue&type=script&lang=js&"
export * from "./ellipsis.vue?vue&type=script&lang=js&"
import style0 from "./ellipsis.vue?vue&type=style&index=0&id=57ffd7fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ffd7fc",
  null
  
)

export default component.exports